import React from 'react';

const KpiCard = ({ kpi }) => {
    const isUp = kpi.is_up ?? true;
    const change = kpi.change ?? 0;
    const trendColor = isUp ? '#2e7d32' : '#c62828';
    const arrow = isUp ? '▲' : '▼';
    const sign = isUp ? '+' : '';

    return (
        <div className="kpi-card-col">
            <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-3">
                    <div className="d-flex justify-content-between align-items-start mb-1">
                        <span className="text-muted text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                            {kpi.label}
                        </span>
                        <span className="badge bg-light text-dark" style={{ fontSize: '0.65rem' }}>
                            vs Prev Month
                        </span>
                    </div>
                    <div className="d-flex align-items-baseline gap-2">
                        <h3 className="mb-0 fw-bold" style={{ fontSize: '1.5rem' }}>
                            {kpi.formatted ?? kpi.value ?? '0'}
                        </h3>
                        <span style={{ color: trendColor, fontSize: '0.8rem', fontWeight: 600 }}>
                            {arrow} {sign}{change}%
                        </span>
                    </div>
                    <div className="mt-1">
                        <small className="text-muted">Previous: {kpi.previous ?? '0'}</small>
                    </div>
                    {(kpi.sparkline && kpi.sparkline.length > 1) ? (
                        <Sparkline data={kpi.sparkline} />
                    ) : null}
                </div>
            </div>
        </div>
    );
};

const Sparkline = ({ data, width = 120, height = 24 }) => {
    if (!data || data.length < 2) return null;

    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const padding = 2;
    const plotW = width - padding * 2;
    const plotH = height - padding * 2;

    const points = data.map((v, i) => {
        const x = padding + (i / (data.length - 1)) * plotW;
        const y = padding + plotH - ((v - min) / range) * plotH;
        return `${x},${y}`;
    }).join(' ');

    const fillPoints = [...data.map((v, i) => {
        const x = padding + (i / (data.length - 1)) * plotW;
        const y = padding + plotH - ((v - min) / range) * plotH;
        return `${x},${y}`;
    }), `${padding + plotW},${padding + plotH}`, `${padding},${padding + plotH}`].join(' ');

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="mt-1">
            <polygon points={fillPoints} fill="rgba(59,130,246,0.08)" />
            <polyline points={points} fill="none" stroke="#3B82F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

const KpiCards = ({ cards }) => {
    if (!cards || cards.length === 0) {
        return (
            <div className="alert alert-info">No KPI data available for this month.</div>
        );
    }

    return (
        <div className="kpi-grid">
            {cards.map((kpi) => (
                <KpiCard key={kpi.key || kpi.label} kpi={kpi} />
            ))}
        </div>
    );
};

export default KpiCards;
